import React, { useEffect,useState } from "react";
import "./index.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import patientAvatar from "./avatar.png";
import Button from "@mui/material/Button";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { api } from "services/ApiService";
import { getPastHistoryDates } from "helpers/daysUtil";
import PaginationComponent from "components/common/pagination/PaginationComponent";
// import { getUserId } from "../../../../auth/authenticate";
import { getUserId } from "auth/authenticate";
import { CircularProgress } from "@mui/material";

export const EarningHistory = (props) => {
  const navigate = useNavigate();
  // let userValue = useContext(UserContext);
  // let { user_id, user_type } = userValue;
  let user_type = 2;
  const [input, setinput] = useState("");
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [dateFilters, setDateFilters] = useState([]);
  const [dateFilter, setDateFilter] = useState('');
  //pagination
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const [offset, setOffset] = React.useState(0);
  const [limit, setLimit] = React.useState(10);

  useEffect(() => {
    setDateFilters(getPastHistoryDates());
    getPayments();
  }, [])

  useEffect(() => {
    getPayments();
  }, [dateFilter, page]);

  const getPayments=async()=>{
    setLoading(true);
    const dates= await getPastHistoryDates();
    const obj = {
      offset: offset,
      limit: 10,
      startDate:
        dateFilter !== "" && dateFilter !== "ALL"
          ? dateFilter
          : dates[dates?.length - 1]?.value,
      endDate:
        dateFilter !== "" && dateFilter !== "ALL"
          ? dates.find((item) => {
              if (item.value === dateFilter) {
                return item;
              }
            }).end
          : new Date().toLocaleDateString("sv-SE"),
    };
    const response = await api(
      `${process.env.REACT_APP_BACKEND_URL}payment/patient/${getUserId()}`,
      "GET", 
      obj
    );
    if (response?.data) {
      setPageCount(Math.ceil(response?.data?.count / limit));
      setPayments(response?.data?.rows);
    }
    setLoading(false);
  }

  const handleChange = (value) => {
    setPage(value);
    if (value - 1 > 0) {
      setOffset((value - 1) * limit);
    } else {
      setOffset(0);
    }
  };

  const handleSelectChange = (event) => {
    setDateFilter(event.target.value);
  };

  if (loading) {
    return (
      <center style={{ marginTop: 250 }}>
        <CircularProgress />
      </center>
    );
  }

  return (
    <div className="earningHistoryMain">
      <Grid container sx={{display:'flex', justifyContent:'space-between'}}>
        <Grid item xs={6} sm={8} md={9} lg={9.5}>
          <div className="earningHistoryMainHeading">
            <div onClick={() => navigate(-1)}>
              <ArrowCircleLeftOutlinedIcon
                className="earningHistoryMainHeadingIcon"
                fontSize="large"
              />
            </div>
              <h3>Payments</h3>
          </div>
        </Grid>
        <Grid item xs={4} sm={4} className="earningHistoryMainHeading">
            
            <Box sx={{ minWidth: 120,}} className="filterPayment">
              <FormControl fullWidth>
                <InputLabel id="filter-appointments-label">Filter</InputLabel>
                <Select
                  labelId="filter-appointments-label"
                  id="demo-simple-select"
                  value={dateFilter}
                  label="Payments"
                  onChange={handleSelectChange}
                >
                  <MenuItem value={"ALL"}>All</MenuItem>
                {dateFilters.map((item, key) => (
                  <MenuItem value={item?.value}>{item?.name}</MenuItem>
                ))}
                </Select>
              </FormControl>
            </Box>

        </Grid>
          
      </Grid>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: "100%",
            height: "auto",
          },
        }}
      >
        <div className="scroll">
          {payments?.map((item,key) => {
            return (
              <div key={key}>
                <Paper elevation={1} className="earningHistoryData">
                  <Grid container className="earningHistoryGrid">
                    <Grid item xs={6} md={4} lg={7}>
                      <div className="earnigHistoryMonth">
                        <h6 className="textCapitalization">{item?.paymentCategory}</h6>
                      </div>
                    </Grid>
                    <Grid item xs={6} md={4} lg={2.5}>
                        <Stack direction="row" spacing={2}>
                          <Avatar alt="Patient Avatar" src={patientAvatar} />
                          <div className="historyPatientName">
                            <h6 className="textCapitalization">{item?.Appointment?.Doctor?.name}</h6>
                            <p className="textCapitalization">{item?.payMedia}</p>
                          </div>
                        </Stack>
                    </Grid>
                    <Grid item xs={6} md={2} lg={1.5}>
                      <div className="earnigHistoryDate">
                        <p>Date</p>
                        <h6>{item?.createdAt?.split("T")[0]}</h6>
                      </div>
                    </Grid>
                    <Grid item xs={3} md={2} lg={1}>
                      <div className="earnigHistoryMoney">
                        <h6>LKR {item?.txnAmount}</h6>
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </div>
            );
          })}
          {payments?.length === 0 && (
            <h4 style={{ textAlign: "center", marginTop: "100px" }}>
              No Items Found...
            </h4>
          )}
        </div>
        {/* Pagination */}
        {pageCount > 0 && (
          <PaginationComponent
            count={pageCount}
            page={page}
            onChangeItem={handleChange}
          />
        )}
      </Box>
    </div>
  );
};
